<!-- <div class="container-fluid" style="overflow: auto;"> -->
<div class="container-fluid gx-5">
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;"><fa-icon class="fa-solid fa-duotone"
            [icon]="['fad', 'memo-circle-info']"></fa-icon> About
        </h3>
      </div>
      <div style="margin-top: 40px; margin-left: auto; margin-right: auto; ">
        <!-- <h3 style="text-align: left;">About</h3> -->
        <div class="mt-4 p-5 bg-primary text-white rounded">
          <h4>Its the Angular/Electron Database Management Application</h4>
          <p>Version: {{version}}</p>
          <p>Api Url: {{apiUrl}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
